<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    append-to-body
    :close-on-click-modal="false"
    class="attendance-dialog"
  >
    <!-- 内容 -->
    <div class="select-content">
      <el-table :data="tableData" ref="table" v-load="tableLoading" border :loading-text="$t('989')">
        <el-table-column
          v-for="el in tableColumns"
          class="cloumn"
          :key="el.field_name"
          :prop="el.field_key"
          :label="el.field_name"
          align="center"
        >
          <template slot="header">
            <el-tooltip v-if="el.remark" class="item" effect="dark" :content="el.remark" placement="top-start">
              <i class="el-icon-warning icon-button"></i>
            </el-tooltip>
            <span>{{ el.field_name }}</span>
          </template>
          <template slot-scope="{ row }">
            <!-- 当数据结构为数组 则按照多行展示 -->
            <div v-if="Array.isArray(row[el.field_key])">
              <p v-for="item in row[el.field_key]" :key="el.field_key + item">{{ item }}</p>
            </div>
            <span v-else>{{ row[el.field_key] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 底部操作栏 -->
    <span slot="footer" class="dialog-footer">
      <!-- 分页 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-size="form.page_size"
        background
        layout="total, prev, pager, next, jumper"
        :total="form.count"
      ></el-pagination>
    </span>
  </el-dialog>
</template>

<script>
import { attendanceDays } from 'api/Attendance/monthly-statistics'
export default {
  data() {
    return {
      title: '',
      tableColumns: [],
      form: {
        count: 0,
        page: 1, // 分页页码
        page_size: 20, // 是每页条数
        start_date: '', // 开始时间
        end_date: '', // 结束时间
        staff_id: '', // 员工ID
        type: '', // 类型 1出勤天数详情、2出勤时长详情、3缺勤天数详情、4休息日详情、5公共假期、6缺卡次数、7迟到详情、8早退详情、9请假详情、10出差、11休息日上班详情、12工作日加班详情、13休息日加班详情
        month_cycle_id: '' // 周期ID（获取出勤天数详情时必填）
      },
      visible: false,
      tableData: [],
      tableLoading: false
    }
  },
  methods: {
    init(form) {
      // console.log(form)
      this.visible = true
      // 默认以传参为准
      this.form = Object.assign(this.form, form)
      // 获取表格详情
      this.getAttendanceDays()
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getAttendanceDays()
    },
    // 获取表格数据
    getAttendanceDays() {
      attendanceDays(this.form).then(res => {
        const { head, data_list, total_count, title } = res.data
        this.tableColumns = head
        this.tableData = data_list
        this.form.count = total_count
        // 弹窗标题
        this.title = title
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.attendance-dialog {
  width: 100%;
  /deep/ .el-dialog {
    width: 1250px;
    max-width: 1250px;
  }
}
</style>
